(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name dutySheet.controller:ConfirmGDPrintCrewTypeDialogCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('dutySheet').controller('ConfirmGDPrintCrewTypeDialogCtrl',
			ConfirmGDPrintCrewTypeDialogCtrl);

	function ConfirmGDPrintCrewTypeDialogCtrl($uibModalInstance, modalParams) {
		var vm = this;
		vm.ctrlName = 'gdPrintCrewTypeCtrl';

		vm.model = {
			title : modalParams.title,
			crewTypes : modalParams.crewTypes || []
		};

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

		vm.onContinueClick = function() { 
			$uibModalInstance.close(modalParams.crewTypes);
		}; 
	}
}());
